
export class Onebet {
    constructor(
        public id: string,
        public bet: string,
        public category: string,
        public cdate: Date,
        public dateOfEvent: Date,
        public event: string,
        public momios: string,
        public status: string,
        public title: string,
    ) { }

}
